import { Brand, BrandConfig } from '../brand.interface';
import { deletemeDigitalFootprint } from './digital-footprint.config';
import { deletemeMenu } from './menu.config';

/**
 * DeleteMe Brand Configuration
 * Primary brand with all features enabled and 12 digital footprint categories
 */
export const DELETEME_BRAND_CONFIG: BrandConfig = {
  brand: {
    name: Brand.DeleteMe,
    displayName: 'deleteme',
    tagline: 'Your Privacy, Protected',
  },

  company: {
    usa: {
      name: 'Deleteme USA LLC',
      address: '1111B S Governors Ave #40073',
      city: 'Dover, DE 19904',
      country: 'United States',
    },
    europe: {
      name: 'Deleteme Europe Ltd',
      address: '16 Stasikratous',
      city: 'Nicosia, 1065',
      country: 'Cyprus',
    },
  },

  urls: {
    main: 'https://www.deleteme.com',
    terms: 'https://www.deleteme.com/terms-and-conditions/',
    privacy: 'https://www.deleteme.com/privacy-policy/',
    privacyCenter: 'https://privacy.deleteme.com',
    help: 'https://help.deleteme.com',
    contact: 'https://www.deleteme.com/contact',
  },

  emails: {
    sales: 'sales@deleteme.com',
    support: 'support@deleteme.com',
    databrokers: 'databrokers@deleteme.com',
  },

  whatsapp: [
    { region: 'Europe', display: '+357 94 096983', link: '35794096983' },
    // { region: 'USA', display: '+1 302-440-8206', link: '13024408206' },
    { region: 'International', display: '+357 94 096983', link: '35794096983' },
  ],

  chat: {
    enabled: true,
    widgetId: '7594569974',
    scriptUrl: 'https://help.deleteme.com/js/embed.js',
  },

  features: {
    // Removal services
    dataBrokerRemovals: true,
    dataBreachRemovals: true,
    dataBreachSubscription: true,
    searchEngineRemovals: true,
    customRemovals: true,
    doxbinRemovals: false,
    kycRemovals: false,

    // Reports
    digitalFootprintReports: true,
    breachLeakReports: true,
    privacyMeterReports: true,
    enhancedReputationReports: true,

    // Subscriptions
    alertSubscriptions: true,

    // Other
    privacyCenter: true,
    billing: true,
    contactUs: true,
  },

  menu: deletemeMenu,
  digitalFootprint: deletemeDigitalFootprint,

  theme: {
    primaryColor: '#2f4295',
    primaryColorPalette: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '#2f4295',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
    logo: 'assets/logo.svg',
    logoIcon: 'assets/logo-icon.svg',
    favicon: 'assets/favicon.ico',
  },
};
